const fieldsLademanagement = [
  'PDB_EundL_Lademanagement_Status',
  'PDB_EundL_Lademanagement_Smart1Controller',
  'PDB_EundL_Lademanagement_DokumentationSmart1Vorhanden',
  'PDB_EundL_Lademanagement_TMHChargepilot',
  'PDB_EundL_Lademanagement_DokumentationTMHVorhanden',
  'PDB_EundL_Lademanagement_InternesLademanagement',
  'PDB_EundL_Lademanagement_SeriennummerLLMController',
  'PDB_EundL_Lademanagement_ZugangZumLastmanagement',
  'PDB_EundL_Lademanagement_IBNProtokollLLEMSvorhanden',
]
const keyLademanagement = "EnergieUndLademanagementkonzept_Lademanagement"
const formGroupLademanagement = { key: keyLademanagement, title: keyLademanagement, form: keyLademanagement }

const fieldsAnforderung = [
  'PDB_EundL_Anforderung_StatischesLademanagement',
  'PDB_EundL_Anforderung_DocuStatischesMgmntVorhanden',

  'PDB_EundL_Anforderung_DynamischesLademanagement',
  'PDB_EundL_Anforderung_DocuDynamischesMgmntVorhanden',

  'PDB_EundL_Anforderung_Schieflastbegrenzung',
  'PDB_EundL_Anforderung_DocuSchieflastbegrenzungVorhanden',

  'PDB_EundL_Anforderung_PVIntegration',
  'PDB_EundL_Anforderung_PVIntegration_fertig',
  'PDB_EundL_Anforderung_DocuPVIntegrationVorhanden',

  'PDB_EundL_Anforderung_BatteriespeicherIntegration',
  'PDB_EundL_Anforderung_BatterieIntegration',
  'PDB_EundL_Anforderung_DocuBatterieIntegrationVorhanden',

  'PDB_EundL_Anforderung_Nutzerpriorisierung',
  'PDB_EundL_Anforderung_Nutzerpriorisierung_fertig',
  'PDB_EundL_Anforderung_DocuNutzerpriorisierungVorhanden',

  'PDB_EundL_Anforderung_Ladepunktpriorisierung',
  'PDB_EundL_Anforderung_Ladepunktpriorisierung_fertig',
  'PDB_EundL_Anforderung_DocuLadepunktpriorisierungVorhanden',
]
const keyAnforderung = "EnergieUndLademanagementkonzept_Anforderung"
const formGroupAnforderung = { key: keyAnforderung, title: keyAnforderung, form: keyAnforderung }

const key = "EnergieUndLademanagementkonzept"
export const fieldOrderEnergieUndLademanagementkonzept = {
  [keyLademanagement]: { fields: fieldsLademanagement },
  [keyAnforderung]: { fields: fieldsAnforderung },
}
export const formGroupEnergieUndLademanagementkonzept = {
  key,
  title: key,
  forms: [formGroupLademanagement, formGroupAnforderung],
}
